"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PulseStageOptions = exports.PulseStageSingleValue = void 0;
const react_1 = __importDefault(require("react"));
const isFunction_1 = __importDefault(require("lodash/isFunction"));
const styles_modules_less_1 = __importDefault(require("./styles.modules.less"));
const PulseStageSingleValue = (props) => {
    const { data } = props;
    return (react_1.default.createElement("div", { className: styles_modules_less_1.default['stage-select__option'] },
        react_1.default.createElement("span", { className: styles_modules_less_1.default['stage-select__option--index'] }, data === null || data === void 0 ? void 0 : data.prefix),
        react_1.default.createElement("span", { className: styles_modules_less_1.default['stage-select__option--label'] }, data.label)));
};
exports.PulseStageSingleValue = PulseStageSingleValue;
const PulseStageOptions = (props) => {
    const { data, handleChangeOption } = props;
    const handleClick = () => {
        if ((0, isFunction_1.default)(handleChangeOption) && data)
            handleChangeOption(data);
    };
    return (react_1.default.createElement("div", { className: styles_modules_less_1.default['stage-select__option'], onClick: handleClick },
        react_1.default.createElement("span", { className: styles_modules_less_1.default['stage-select__option--index'] }, data === null || data === void 0 ? void 0 : data.prefix),
        react_1.default.createElement("span", { className: styles_modules_less_1.default['stage-select__option--label'] }, data === null || data === void 0 ? void 0 : data.label)));
};
exports.PulseStageOptions = PulseStageOptions;
